import React, { ReactNode, RefObject } from 'react';
import { I18n, Translate } from 'react-redux-i18n';
import logo from '../../../img/logo-idnot.png';
import Button from '../../common/Button';
import { getLinks } from '../../../network/api/links';

type Props = {
  index: number;
  divRef: RefObject<HTMLDivElement>,
  percentOfStep: number,
  title: string,
  progressBarRef: RefObject<HTMLDivElement>,
};

type State = {
};

class ActivationHeader extends React.Component<Props, State> {
  state: State = {};

  render(): ReactNode {
    return (
      <div ref={this.props.divRef} className="activation-header">
        <div className="label-container">
          <div className="back-button">
            <a
              aria-label="Se connecter"
              href={getLinks().connectionLink}
            >
              <Button
                type="secondary"
                i18nKey="HEADER.CONNECTION"
              />
            </a>
          </div>
          <div className="main-content">
            <div>
              <img className="logo" src={logo} alt="logo" />
            </div>
            <div>
              <h3>
                <Translate value={this.props.title} />
              </h3>
              <div className="subtitle">
                <Translate value="HEADER.UNIQUE_ACCOUNT" />
              </div>
            </div>
          </div>
          <div className="filler" />
        </div>
        <div className="progress-bar-container">
          <div ref={this.props.progressBarRef} style={{ width: `${this.props.percentOfStep * (this.props.index + 1)}%` }} className="progress-bar-content" />
        </div>
      </div>
    );
  }
}

export default ActivationHeader;
